import { render, staticRenderFns } from "./citasPendientes.vue?vue&type=template&id=13063076&lang=pug&"
import script from "./citasPendientes.vue?vue&type=script&lang=js&"
export * from "./citasPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports